let amplitude;
if (typeof window !== "undefined") {
  amplitude = window.amplitude;
}

export const logEvent = (eventName, properties = {}) => {
  amplitude.getInstance().logEvent(eventName, properties);
};
